import { render } from "./ProjectSettingsModal.vue?vue&type=template&id=437cbdc5&scoped=true"
import script from "./ProjectSettingsModal.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsModal.vue?vue&type=script&lang=js"

import "./ProjectSettingsModal.vue?vue&type=style&index=0&id=437cbdc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437cbdc5"]])

export default __exports__